var TitleAlignments;
(function (TitleAlignments) {
    TitleAlignments["Center"] = "center";
    TitleAlignments["Start"] = "start";
    TitleAlignments["End"] = "end";
})(TitleAlignments || (TitleAlignments = {}));
var ExpandStates;
(function (ExpandStates) {
    ExpandStates["Full"] = "Full";
    ExpandStates["Default"] = "Default";
    ExpandStates["Minimized"] = "Minimized";
    ExpandStates["Closed"] = "Closed";
})(ExpandStates || (ExpandStates = {}));
var BottomSheetTypes;
(function (BottomSheetTypes) {
    BottomSheetTypes["Dynamic"] = "Dynamic";
    BottomSheetTypes["Static"] = "Static";
})(BottomSheetTypes || (BottomSheetTypes = {}));

export { BottomSheetTypes, ExpandStates, TitleAlignments };
